module.exports = __webpack_public_path__ + "img/icon-label1.edc31f4c.svg";